import { z } from 'zod';

const optionalOverride = z
  .string()
  .trim()
  .transform((value) => value || undefined)
  .optional();

export const localEnvironment = z
  .object({
    VITE_LOCAL_API_URL: optionalOverride.pipe(z.url().optional()),
  })
  .parse(import.meta.env.DEV ? import.meta.env : {});
